let _injected = false;

/**
 * Injects the LivePerson Monitor tag bootstrap into the document head.
 *
 * Mirrors the official LivePerson Monitor snippet (previously inlined in
 * index.html) but takes the account/site ID from configuration instead of a
 * hardcoded value. The chat does not auto-start (`autoStart: false`); the
 * window is only shown once `window.lpTag.start()` is called.
 *
 * @param accountId LivePerson account/site ID (numeric string).
 */
export function initLivePersonTag(accountId: string): void {
  if (typeof window === "undefined") {
    return;
  }

  if (_injected) {
    return;
  }

  // Account IDs are numeric LivePerson site IDs. Validate strictly both to
  // avoid loading the tag with an invalid value and to prevent injecting
  // arbitrary content into the inline bootstrap script.
  if (!/^\d+$/.test(accountId)) {
    return;
  }

  // Already initialized elsewhere (e.g. a previous call)
  if (window.lpTag) {
    _injected = true;
    return;
  }

  _injected = true;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.text = buildBootstrap(accountId);
  document.head.appendChild(script);
}

function buildBootstrap(accountId: string): string {
  return `window.lpTag = window.lpTag || {}, 'undefined' == typeof window.lpTag._tagCount ? (window.lpTag = { wl: lpTag.wl || null, scp: lpTag.scp || null, site: '${accountId}' || '', section: lpTag.section || '', tagletSection: lpTag.tagletSection || null, autoStart: false, ovr: lpTag.ovr || {}, _v: '1.10.0', _tagCount: 1, protocol: 'https:', events: { bind: function (t, e, i) { lpTag.defer(function () { lpTag.events.bind(t, e, i) }, 0) }, trigger: function (t, e, i) { lpTag.defer(function () { lpTag.events.trigger(t, e, i) }, 1) } }, defer: function (t, e) { 0 === e ? (this._defB = this._defB || [], this._defB.push(t)) : 1 === e ? (this._defT = this._defT || [], this._defT.push(t)) : (this._defL = this._defL || [], this._defL.push(t)) }, load: function (t, e, i) { var n = this; setTimeout(function () { n._load(t, e, i) }, 0) }, _load: function (t, e, i) { var n = t; t || (n = this.protocol + '//' + (this.ovr && this.ovr.domain ? this.ovr.domain : 'lptag.liveperson.net') + '/tag/tag.js?site=' + this.site); var o = document.createElement('script'); o.setAttribute('charset', e ? e : 'UTF-8'), i && o.setAttribute('id', i), o.setAttribute('src', n), document.getElementsByTagName('head').item(0).appendChild(o) }, init: function () { this._timing = this._timing || {}, this._timing.start = (new Date).getTime(); var t = this; window.attachEvent ? window.attachEvent('onload', function () { t._domReady('domReady') }) : (window.addEventListener('DOMContentLoaded', function () { t._domReady('contReady') }, !1), window.addEventListener('load', function () { t._domReady('domReady') }, !1)), 'undefined' === typeof window._lptStop && this.load() }, start: function () { this.autoStart = !0 }, _domReady: function (t) { this.isDom || (this.isDom = !0, this.events.trigger('LPT', 'DOM_READY', { t: t })), this._timing[t] = (new Date).getTime() }, vars: lpTag.vars || [], dbs: lpTag.dbs || [], ctn: lpTag.ctn || [], sdes: lpTag.sdes || [], hooks: lpTag.hooks || [], identities: lpTag.identities || [], ev: lpTag.ev || [] }, lpTag.init()) : window.lpTag._tagCount += 1;`;
}
